import { registerCardTemplate } from "../../../common/common";
import { lazyTemplate } from "../../lazyTemplate";
import { generateIconProp } from "../../../common/icon-selector/IconEditor";

registerCardTemplate({
    id: 'video-card',
    name: "Video Card",
    description: 'Video Player card',
    template: lazyTemplate(() => import(/* webpackChunkName: "tpl-video-card" */ "./VideoCardTemplate")),
    icon: generateIconProp('video'),
    complexity: 'easy',
});
